/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Profile picture component
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-profile-picture[_ngcontent-%COMP%]{border-radius:50%;text-align:center;color:#fff;font-weight:700;text-shadow:1px 1px 4px #000;border:1px solid rgba(0,0,0,.3)}"];
export { styles as styles };
